import clsx from "clsx";
import type { PropsWithChildren } from "react";
import { DefaultContainerVariantProps, defaultContainerVariants } from "@/components/shared/DefaultContainer/defaultContainerVariants";

type Props = DefaultContainerVariantProps &
    PropsWithChildren & {
        className?: string;
    };

export function DefaultContentContainer({ children, className, rounded, shadow, theme }: Props) {
    const styles = defaultContainerVariants({ rounded, shadow, theme });

    return <div className={clsx(styles, className)}>{children}</div>;
}

export default DefaultContentContainer;
